import React, { useState } from 'react'
import { Header, Modal, Button, Icon, Card, Grid, Label, Divider, Table } from 'semantic-ui-react'
import ShowMoreText from "react-show-more-text";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from 'swiper/react';

import "./AccommodationBathrooms.css"

const rooms = [
    {
        title: "سرویس بهداشتی",
        type: "توالت ایرانی",
        position: "حیاط",
        facilities: false,

    },
    {
        title: "حمام",
        type: "توالت فرنگی٬ دوش",
        position: "داخل واحد",
        facilities: {
            Shower: true,
            Tub: true,
            Jacuzzi: false
        },
    }
]
const AccommodationBathrooms = () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false)
    return (<>
        <Header as='h3'>{t("property:BathroomInfo")}</Header>
        <p>{t("property:BathroomInfoText")}</p>
        <Swiper
            spaceBetween={50}
            slidesPerView={3}
        >
            {
                rooms.map((item, index) => {
                    return <SwiperSlide key={index} className="m-1">
                        <Card>
                            <Card.Content>
                                <Card.Header>{item.title}</Card.Header>
                                <Card.Description>
                                    {item.type}
                                </Card.Description>
                                <Card.Meta className="m-05-t"><Label basic color="blue">{item.position}</Label></Card.Meta>

                            </Card.Content>
                        </Card>
                    </SwiperSlide>
                })
            }


        </Swiper>


        <Modal
            size="small"
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            open={open}
            trigger={<Button size="big" className="m-1-t m-1-b  p-1-t p-1-b p-0 bg-transparent text-blue" >{t("property:BathroomDetails")}
                <Icon name="chevron right" /></Button>}>
            <Modal.Header>{t("property:BathroomDetails")}</Modal.Header>
            <Modal.Content scrolling>
                <Modal.Description>
                    <Grid columns={1}>
                        {
                            rooms.map((item, index) => {
                                return <Grid.Column>
                                    <Header as='h2'>{item.title}</Header>



                                    <div className="d-flex flex-row align-items-center">
                                        <Header className="m-05-t m-05-b" as='h3'>
                                            {t("property:Position")} :
                                        </Header>
                                        <p className="m-05">
                                            {item.position}
                                        </p>
                                    </div>

                                    {
                                        item.facilities ?
                                            <Header className="m-05-t m-05-b" as='h3'>
                                                {t("property:BathroomFacilities")} :
                                            </Header> : null
                                    }
                                    {
                                        item.facilities ?
                                            Object.keys(item.facilities).map(function (key, keyIndex) {
                                                return <Header as='h4'>
                                                    <Header.Content>
                                                        {
                                                            item.facilities[key] ? t(`property:${key}`) : <span className="text-lined">{t(`property:${key}`)}</span>
                                                        }
                                                    </Header.Content>
                                                </Header>
                                            }) : null
                                    }
                                    <Divider />
                                </Grid.Column>
                            })
                        }
                    </Grid>

                </Modal.Description>
            </Modal.Content>
        </Modal>
    </>
    )
}
export default AccommodationBathrooms